/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteHairdresserSalons = gql`
  mutation DeleteHairdresserSalons($ids: [ID!]!) {
    deleteHairdresserSalons(ids: $ids)
  }
`;
